import { render, staticRenderFns } from "./ContactAsset.vue?vue&type=template&id=407543f9"
import script from "./ContactAsset.vue?vue&type=script&lang=js"
export * from "./ContactAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407543f9')) {
      api.createRecord('407543f9', component.options)
    } else {
      api.reload('407543f9', component.options)
    }
    module.hot.accept("./ContactAsset.vue?vue&type=template&id=407543f9", function () {
      api.rerender('407543f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactAsset.vue"
export default component.exports